import { IconButton } from '@mui/material'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import Link from 'next/link'
import { HIDDEN_WITH_BOTTOM_NAV } from './bottomNavStyles'

export interface HeaderHomeButtonProps {
  href: string
  color?: string
  borderColor?: string
  isDark?: boolean
}

export const HeaderHomeButton = ({
  href,
  color = 'white',
  borderColor = 'rgba(255,255,255,0.4)',
  isDark = false,
}: HeaderHomeButtonProps) => {
  return (
    <IconButton
      component={Link}
      href={href}
      aria-label="Go to homepage"
      sx={{
        color: isDark ? 'white' : color,
        width: '42px',
        height: '42px',
        borderRadius: '0.5rem',
        border: `1px solid ${isDark ? 'rgba(37, 36, 36, 0.71)' : borderColor}`,
        ...(isDark && {
          bgcolor: '#0F1E27',
          boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
        }),
        '&:hover': {
          bgcolor: isDark ? '#1a2c38' : 'rgba(255,255,255,0.05)',
        },
        ...HIDDEN_WITH_BOTTOM_NAV,
      }}
    >
      <HomeOutlinedIcon sx={{ fontSize: '24px' }} />
    </IconButton>
  )
}
